export async function callApiWithResult(apiPromise) {
  try {
    const response = await apiPromise;
    return response.data;
  } catch (error) {
    throw error.error;
  }
}
